const useDebug = (name, ...props) => {
  console.log(`[Component Debug]: ${name}`, props)
}

export default useDebug